import { CardType, Patient } from "@/src/data/allTypes";
import { allItemTypes } from "@/src/data/data";
import { USER } from "@/src/data/globalVariables";
import { isCabinet, uid } from "@/src/utils/utils";
import { useRef, useState } from "react";
import { OrdonnancesHistory } from "../hospitalisation/ordonnancesCompartment";
import { AppointmentsHistory } from "./appointmentsHistory";
import { ConsultationsHistory } from "./consultationsHistory";
import { CuresHistory } from "./curesHistory";
import { DocumentsHistory } from "./documentsHistory";
import { ExamsHistory } from "./examsHistory";
import { HospitalisationsHistory } from "./hospitalisationsHistory";
import { MesuresHistory } from "./mesuresHistory";
import { RadiotherapiesHistory } from "./radiotherapyHistory";
import { SurgeriesHistory } from "./surgeriesHistory";
import { UploadsHistory } from "./uploadsHistory";
import { AiDescription } from "../aiTasks/aiDescription";

function PatientHistory({
  patient,
  historyType,
  onHistoryTypeChange,
}: {
  patient: Patient;
  historyType?: string | null | undefined;
  onHistoryTypeChange?: (newValue: string) => void;
}) {
  // return <div></div>;
  let isOncology = USER.get()
    ?.speciality?.name?.toLowerCase()
    ?.includes("cancer");
  const [tabId, setTabId] = useState(
    historyType ||
      (isOncology ? "cures" : isCabinet() ? "consultation" : "hospitalisation")
  );

  const historyTabs: {
    id: string;
    name: string;
    content: any;
    shouldDisplay?: boolean;
  }[] = [
    // {
    //   id: "summary",
    //   name: "Résumé",
    //   content: <div></div>,
    // },
    {
      id: "hospitalisation",
      name: "Hospitalisations",
      content: <HospitalisationsHistory patient={patient} />,
      shouldDisplay: !isCabinet(),
    },
    {
      id: "consultation",
      name: "Consultations",
      content: <ConsultationsHistory patient={patient} />,
    },

    {
      id: "exam",
      name: "Examens",
      content: <ExamsHistory patient={patient} />,
    },
    {
      id: "appointment",
      name: "Rendez-vous",
      content: (
        <AppointmentsHistory
          title="Rendez-vous"
          patient={patient}
          types={null}
        ></AppointmentsHistory>
      ),
    },

    {
      id: "document",
      name: "Documents",
      content: <DocumentsHistory patient={patient} parent={null} />,
    },
    {
      id: "upload",
      name: "Fichiers",
      content: <UploadsHistory patient={patient}></UploadsHistory>,
    },
    {
      id: "ordonnance",
      name: "Ordonnances",
      content: <OrdonnancesHistory patient={patient} parent={null} />,
    },

    {
      id: "mesure",
      name: "Mesures",
      content: (
        <MesuresHistory patient={patient} parent={null}></MesuresHistory>
      ),
    },

    {
      id: "cure",
      name: "Cures",
      content: (
        <CuresHistory
          title="Cures"
          patient={patient}
          types={null}
        ></CuresHistory>
      ),
    },

    {
      id: "radiotherapy",
      name: "Radiothérapies",
      content: <RadiotherapiesHistory patient={patient} />,
    },
    {
      id: "surgeries",
      name: "Chirurgies",
      content: <SurgeriesHistory patient={patient} />,
    },
  ];

  const selectedTab = historyTabs.find((tab) => tab.id == tabId);
  return (
    <div>
      <div className="c1 gap10">
        {
          <div className="historyTabs ">
            {historyTabs.map((tab) => {
              if (tab.shouldDisplay === false) return null;
              return (
                <HistoryTab
                  key={uid()}
                  activeTabId={tabId}
                  type={tabId as any}
                  id={tab.id}
                  name={tab.name}
                  onChange={(tab) => {
                    onHistoryTypeChange?.(tab);
                    setTabId(tab);
                  }}
                />
              );
            })}
          </div>
        }
      </div>
      <div className="mtop10">{selectedTab?.content}</div>
    </div>
  );
}

function HistoryTab({
  activeTabId,
  type,
  id,
  name,
  onChange,
}: {
  activeTabId: string;
  type?: CardType;
  id: string;
  name: string;
  onChange: (tab: string) => void;
}) {
  let typeInfo = type ? allItemTypes[type] : null;
  let isActive = activeTabId == id;
  const ref = useRef<HTMLDivElement>(null);

  return (
    <AiDescription
    item={{
      type: "tab",
      title: name,

      description: `A navigation tab for the patient history that goes to the ${name} tab which enables the user to see the ${name} history and add new items to it. ${isActive ? "This tab is currently active (You do not need to click on it again)." : "This tab is NOT currently active."}`,
      ref,
      isClickable: true,
    }}
  >
      <div
        ref={ref}
        className={`tab tcenter ${isActive ? "active" : ""}`}
        style={{ background: isActive ? typeInfo?.secondaryColor || "" : "" }}
        onClick={() => {
          onChange(id);
        }}
      >
        <div
          className="chip_title"
          style={{ color: isActive ? typeInfo?.color : "" }}
        >
          {name}
        </div>
      </div>
    </AiDescription>
  );
}

export { PatientHistory };
